import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import Swal from "sweetalert2";
import { ProductContext } from "../context/AppContext";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import axios from "axios";

const ExamInterview = () => {
  const navigate = useNavigate();
    const { examId, bookingId } = useParams();
    const { getRegistration } = useContext(ProductContext);
    const Regi_id = Number(getRegistration?.data?.id);
  
    const [loading, setLoading] = useState(false);
    const [loadingExamId, setLoadingExamId] = useState(null);
    const [getExamInterviewData, setGetExamInterviewData] = useState(null);
  
    const authtoken = localStorage.getItem("token");

    const [Dashboarddata, setDashboarddata] = useState(null);

  const fetchUserData = async () => {
    if (!authtoken) {
      console.log("No token found");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        "https://api.mirai.healthcare/api/register/dashboard",
        {
          headers: {
            "x-auth": `${authtoken}`,
          },
        }
      );

      console.log("API response:", response.data);

      if (response.data.success) {
        setDashboarddata(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  
    // ✅ Fetch Exam Interview Data
    const fetchExamScheduleData = async () => {
      try {
        const response = await fetch(`https://api.mirai.healthcare/api/exam/interview-schedule`, {
          method: "GET",
          headers: {
            "x-auth": authtoken,
          },
        });
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await response.json();
        console.log("Exam Interview Data:", data);
        setGetExamInterviewData(data);
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  
    useEffect(() => {
      fetchExamScheduleData();
      fetchUserData();
    }, []);
  
    // ✅ Handle Booking API
    const handleInterviewPostAPI = async (BookexamId) => {
      setLoading(true);
      try {
        const response = await fetch(
          "https://api.mirai.healthcare/api/exam/interview-booking",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-auth": authtoken,
            },
            body: JSON.stringify({
              interview_slot_id: BookexamId,
              reg_id: Regi_id,
              remarks: "",
            }),
          }
        );
  
        if (!response.ok) {
          const errorText = await response.text();
          console.error("Error Response:", errorText);
          Swal.fire("Error", `Failed to book interview: ${errorText}`, "error");
          return;
        }
  
        const responseData = await response.json();
        console.log("Interview booked:", responseData);
        Swal.fire("Success", "Interview slot booked successfully!", "success");
        await fetchExamScheduleData();
        navigate("/index");
      } catch (error) {
        Swal.fire("Error", `Error: ${error.message}`, "error");
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        {getExamInterviewData ? (
        <div className="content background-color_row">
          <>
            <Header />
{Dashboarddata?.data?.studentInterview ? (
  <div className="d-flex justify-content-center align-items-center vh-100">
  <div className="col-xxl-12 col-sm-12">
    <div className="card flex-fill animate-card border-0 text-center">
      <div className="card-body">
        <h2 className="Main_heading mb-4">
          The student interview has been successfully scheduled. Please go to the home page to view details.
        </h2>
        <Link to ="/" className="btn btn-primary">Home</Link>
      </div>
    </div>
  </div>
</div>
) : (

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header card-buttons">
                    <h5 className="card-title">Interview Schedule</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
  {(() => {
    const upcomingInterviews = getExamInterviewData?.message?.filter((exam) => {
      const interviewDate = new Date(exam?.interview_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return interviewDate >= today;
    }) || [];

    // 👉 If no upcoming interviews found
    if (upcomingInterviews.length === 0) {
      return (
        <div className="col-12">
          <div className="alert alert-basic text-center mt-3" style={{fontWeight:'600'}}>
            No upcoming interview slots available.
          </div>
        </div>
      );
    }

    // 👉 Otherwise, show the cards
    return upcomingInterviews.map((exam, index) => (
      <div className="col-12 col-sm-6 col-md-4" key={index}>
        <div className="card">
          <div className="card-header card-buttons">
            <h5 className="card-title exam_name_heading">
              Date <span>{exam?.interview_date?.split("T")[0] || ""}</span>
            </h5>
          </div>
          <div className="card-body Card_design_1">
            <p>Start Time <span>{exam?.start_time}</span></p>
            <p>End Time <span>{exam?.end_time}</span></p>
            <p>Student Capacity <span>{exam?.student_capacity}</span></p>
            <p>Count <span>{exam?.student_count}</span></p>

            <div className="d-flex align-items-end book_slot">
              <button
                className="d-flex align-items-center btn btn-primary"
                onClick={async () => {
                  setLoadingExamId(exam.id);
                  try {
                    await handleInterviewPostAPI(exam.id);
                  } catch (err) {
                    Swal.fire("Error", "Failed to book slot", "error");
                  } finally {
                    setLoadingExamId(null);
                  }
                }}
              >
                Book Interview
              </button>
            </div>
          </div>
        </div>
      </div>
    ));
  })()}
</div>


                   
                  </div>
                </div>
              </div>
            </div>

  


            )}
          </>
        </div>
        ) : (
          <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
            <Header />
          </div>

        )}
      </div>
      {/* /Page Wrapper */}
    </>
  );
};


export default ExamInterview
